import { createMuiTheme, MuiThemeProvider, Typography, TableCell, withStyles, Tooltip, Snackbar } from '@material-ui/core';
import React, { useState } from 'react'
import CloseImage from '../../assets/ic_close.png';
import { ExcelRenderer } from 'react-excel-renderer';
import UploadFile from "../components/UploadFile";
import api from '../api';
import MUIDataTable from "mui-datatables";
import ic_downloadFile from '../../assets/ic_downloadFile.png';
import { format } from 'date-fns';
import ReactExport from 'react-data-export';
import MuiAlert from '@material-ui/lab/Alert';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()

const style = {
    position: "sticky",
    zIndex: 110
};

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function UploadAppointment(props) {
    const [visibleupload, setvisibleupload] = useState(false)
    const [visiblePreview, setVisiblePreview] = useState(false)
    const [errorPreview, setErrorPreview] = useState(false)
    const [previewSave, setPreviewSave] = useState(false)
    const [percentage, setpercentage] = useState('0')
    const [uploadstatus, setuploadstatus] = useState("")
    const [result, setresult] = useState("")
    const [body, setBody] = useState([])
    const [dataTable, setDataTable] = useState([])
    const [dataTableSave, setDataTableSave] = useState([])
    const [dataPreview, setDataPreview] = useState([])
    const [isUpload, setIsUpload] = useState(false)
    const [multiDataSet, setMultiData] = useState([
        {
            columns: [
                { title: `Template Upload Appointment` }
            ],
            data: [
                [{ value: `` }]
            ]
        },
        {
            ySteps: -1,
            columns: [
                { title: "Doctor Schedules ID", width: { wpx: 80 } },//pixels width 
                { title: "No RM", width: { wpx: 80 } },//pixels width 
                { title: "Nama Pasien", width: { wpx: 80 } },//pixels width 
                { title: "No Telp", width: { wpx: 80 } },//pixels width 
                { title: "No Handphone", width: { wpx: 80 } },//pixels width 
                { title: "Gender", width: { wpx: 80 } },//pixels width 
                { title: "DOB", width: { wpx: 80 } },//pixels width 
                { title: "Alamat", width: { wpx: 80 } },//pixels width 
                { title: "NIK", width: { wpx: 80 } },//pixels width 
                { title: "Sequence", width: { wpx: 80 } },//pixels width 
                { title: "No Antrian", width: { wpx: 80 } },//pixels width 
                { title: "Payment Option", width: { wpx: 80 } },//pixels width 
                { title: "No Rujukan BPJS", width: { wpx: 80 } },//pixels width 
            ],
            data: [
                [3596, "", "Siska Kohl", 822, 822, "P/L", "MM-dd-yyyy", "bgr", 312000, 1, 1, 1, " ",]
            ]
        }

    ])
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [multiDataSave, setMultiDataSave] = useState([])
    const [download, setDownload] = useState(false)

    const onUpload = () => {
        setvisibleupload(true)
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };


    const fileHandler = (event) => {
        let fileObj = event
        ExcelRenderer(fileObj, (err, resp) => {
            console.log(resp)
            if (err) {
                console.log(err);
            }
            else {
                let isi = resp.rows.slice(2)
                let payload = []
                // var date = new Date(Math.round((isi[0][5] - (25567 + 1)) * 86400 * 1000));
                // var converted_date = date.toISOString().split('T')[0];
                // var utc_days = Math.floor(isi[0][5] - 25569);
                // var utc_value = utc_days * 86400;
                // var date_info = new Date(utc_value * 1000);
                console.log(isi);
                // let reg = /^[-+]?(?:[0-9]+,)*[0-9]+(?:\.[0-9]+)?$/;
                let errorRM = []
                let errorDate = []
                let errorGender = []
                let errorPhone = []
                let errorNIK = []
                let errorGreaterDate = []
                isi.map((i, index) => {
                    if (i.length > 0) {
                        // var hours = Math.floor((i[6] % 1) * 24);
                        // var minutes = Math.floor((((i[6] % 1) * 24) - hours) * 60)
                        // var a = new Date(Date.UTC(0, 0, i[6], hours - 17, minutes));
                        // var b = new Date(a)
                        console.log(isNaN(new Date(i[6]).getTime()));
                        // console.log(format(new Date(i[6]), 'yyyy-MM-dd'));
                        let regexNumber = /^[0-9]*$/
                        // if (!i[1]) {
                        //     errorRM.push(index)
                        // }
                        if (!regexNumber.test(i[3])) {
                            errorPhone.push(index)
                        }
                        if (!regexNumber.test(i[8])) {
                            errorNIK.push(index)
                        }
                        if (String(i[5]).toUpperCase() === "P" || String(i[5]).toUpperCase() === "L") {
                            if (!isNaN(new Date(i[6]).getTime())) {
                                payload.push({
                                    doctor_schedule_id: i[0],
                                    queue_number: i[10],
                                    sequence: i[9],
                                    payment_option: i[11],
                                    reference_no: i[12] === undefined ? null : String(i[11]),
                                    patient: {
                                        name: String(i[2]).toUpperCase(),
                                        phone: i[3],
                                        mobile_phone: i[4],
                                        gender: String(i[5]).toUpperCase(),
                                        date_of_birth: format(new Date(i[6]), 'yyyy-MM-dd'),
                                        identity_no: String(i[8]),
                                        address: String(i[7]),
                                        medical_record_no: i[1] === undefined ? "" : String(i[1]),
                                        bpjs_no: null,
                                        bpjs_name: null,
                                    }
                                })
                            } else {
                                errorDate.push(index)
                            }
                        } else {
                            errorGender.push(index)
                        }
                    }
                })
                let body = {
                    "appointment": payload
                }
                console.log(body, errorPhone)
                if (errorPhone.length > 0) {
                    setIsUpload(false)
                    setOpenAlert(true)
                    setMessageAlert(`Terdapat ${errorPhone.length} data Invalid Phone`)
                    setStatusAlert('warning')
                } else if (errorRM.length > 0) {
                    setIsUpload(false)
                    setOpenAlert(true)
                    setMessageAlert(`Terdapat ${errorRM.length} data Invalid Medical Record`)
                    setStatusAlert('warning')
                } else if (errorGender.length > 0) {
                    setIsUpload(false)
                    setOpenAlert(true)
                    setMessageAlert(`Terdapat ${errorGender.length} data Invalid Gender`)
                    setStatusAlert('warning')
                } else if (errorDate.length > 0) {
                    setIsUpload(false)
                    setOpenAlert(true)
                    setMessageAlert(`Terdapat ${errorDate.length} data Invalid DOB`)
                    setStatusAlert('warning')
                } else if (errorGreaterDate.length > 0) {
                    setIsUpload(false)
                    setOpenAlert(true)
                    setMessageAlert(`Terdapat ${errorGreaterDate.length} data Invalid DOB`)
                    setStatusAlert('warning')
                } else if (errorNIK.length > 0) {
                    setIsUpload(false)
                    setOpenAlert(true)
                    setMessageAlert(`Terdapat ${errorNIK.length} data Invalid NIK`)
                    setStatusAlert('warning')
                } else {
                    setBody(body)
                    setIsUpload(true)
                }
            }
        });
    }

    const checkPreview = () => {
        api.create().uploadPreview(body).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.details.length > 0) {
                        let dataTable = response.data.data.details.map((item) => {
                            return [
                                item.doctor_schedule_detail_id,
                                item.doctor_name,
                                item.polyclinic_name,
                                item.schedule_date === null ? '' : format(new Date(item.schedule_date), 'yyyy-MMM-dd'),
                                `${item.time_start} - ${item.time_end}`,
                                item.patient.medical_record_no ? item.patient.medical_record_no : '-',
                                item.patient.name,
                                format(new Date(item.patient.date_of_birth), 'dd-MM-yyyy'),
                                item.patient.identity_no,
                                item.patient.address,
                                item.patient.gender,
                                item.patient.phone ? item.patient.phone : '',
                                item.patient.mobile_phone ? item.patient.mobile_phone : '',
                                item.sequence,
                                item.queue_number,
                                item.payment_option_name,
                                item.reference_no,
                                item.error_message
                            ]
                        })
                        setDataPreview(response.data.data.details)
                        setDataTable(dataTable)
                        if (response.data.data.total_error > 0) {
                            setErrorPreview(true)
                        } else {
                            setErrorPreview(false)
                        }
                    } else {
                        setDataTable([])
                    }
                    setVisiblePreview(true)
                    setvisibleupload(false)

                }
            }
        })
    }

    const handleSave = () => {
        let appointment = []
        if (dataPreview.length > 0) {
            dataPreview.map((item) => {
                appointment.push({
                    "doctor_schedule_detail_id": item.doctor_schedule_detail_id,
                    "queue_number": item.queue_number,
                    "payment_option": item.payment_option,
                    "reference_no": item.reference_no,
                    "patient": {
                        "id": item.patient.id,
                        "name": item.patient.name,
                        "phone": String(item.patient.phone),
                        "mobile_phone": String(item.patient.mobile_phone),
                        "gender": item.patient.gender,
                        "date_of_birth": item.patient.date_of_birth,
                        "identity_no": item.patient.identity_no,
                        "address": item.patient.address,
                        "medical_record_no": item.patient.medical_record_no,
                        "bpjs_no": item.patient.bpjs_no,
                        "bpjs_name": item.patient.bpjs_name
                    }
                })
            })
        }
        let payload = {
            "appointment": appointment
        }
        console.log(payload);
        api.create().savePreview(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setVisiblePreview(false)
                    setDataTable([])
                    setMessageAlert(response.data.message)
                    setStatusAlert('success')
                    setOpenAlert(true)
                    setErrorPreview(false)
                    setPreviewSave(true)
                    let dataTable = response.data.data.details.map((item) => {
                        return [
                            item.doctor_name,
                            item.booking_id,
                            item.queue_number_after,
                            item.polyclinic_name,
                            item.schedule_date === null ? '' : format(new Date(item.schedule_date), 'yyyy-MMM-dd'),
                            `${item.time_start} - ${item.time_end}`,
                            item.patient.medical_record_no,
                            item.patient.name,
                            format(new Date(item.patient.date_of_birth), 'dd-MM-yyyy'),
                            item.patient.identity_no,
                            item.patient.address,
                            item.patient.gender,
                            item.patient.phone,
                            item.patient.mobile_phone,
                            item.sequence,
                            item.payment_option,
                            item.reference_no
                        ]
                    })
                    setDataTableSave(dataTable)
                    let data = []
                    let column = [
                        { title: "Nama Dokter" },
                        { title: "Kode Booking" },
                        { title: "No Antrian" },
                        { title: "Klinik" },
                        { title: "Appointment Date" },
                        { title: "Jam Mulai - Jam Selesai" },
                        { title: "No RM" },
                        { title: "Nama Pasien" },
                        { title: "Tanggal Lahir" },
                        { title: "NIK" },
                        { title: "Alamat" },
                        { title: "Jenis Kelamin" },
                        { title: "No Telepon" },
                        { title: "No Handphone" },
                        { title: "Sequence" },
                        { title: "Opsi Pembayaran" },
                        { title: "No Rujukan" },
                    ]
                    response.data.data.details.map((item) => {
                        data.push([
                            { value: item.doctor_name === null ? '' : item.doctor_name },
                            { value: item.booking_id === null ? '' : item.booking_id },
                            { value: item.queue_number_after === null ? '' : item.queue_number_after },
                            { value: item.polyclinic_name === null ? '' : item.polyclinic_name },
                            { value: item.schedule_date === null ? '' : format(new Date(item.schedule_date), 'yyyy-MMM-dd') },
                            { value: `${item.time_start} - ${item.time_end}` },
                            { value: item.patient.medical_record_no === null ? '' : item.patient.medical_record_no },
                            { value: item.patient.name === null ? '' : item.patient.name },
                            { value: item.patient.date_of_birth === null ? '' : format(new Date(item.patient.date_of_birth), 'dd-MM-yyyy') },
                            { value: item.patient.identity_no === null ? '' : item.patient.identity_no },
                            { value: item.patient.address === null ? '' : item.patient.address },
                            { value: item.patient.gender === null ? '' : item.patient.gender },
                            { value: item.patient.phone === null ? '' : item.patient.phone },
                            { value: item.patient.mobile_phone === null ? '' : item.patient.mobile_phone },
                            { value: item.sequence === null ? '' : item.sequence },
                            { value: item.payment_option === null ? '' : item.payment_option },
                            { value: item.reference_no === null ? '' : item.reference_no },
                        ])
                    })
                    let dataJadi = [
                        {
                            columns: column,
                            data: data
                        }
                    ]
                    setDownload(true)
                    setMultiDataSave(dataJadi)
                }
            }
        })
    }

    const columns = [
        {
            name: "Doctor Schedules ID",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 210 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Nama Dokter",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Klinik",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Appointment Date",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Jam Mulai - Jam Selesai",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No RM",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 110 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Nama Pasien",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Tanggal Lahir",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "NIK",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Alamat",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Jenis Kelamin",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No Telepon",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No Handphone",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Sequence",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No Antrian",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Opsi Pembayaran",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No Rujukan BPJS",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left', color: tableMeta.rowData[17] === null ? 'black' : 'red' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Keterangan Error",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val === null ? "" :
                                <Typography style={{ color: 'red' }}>{val}</Typography>
                            }
                        </div>
                    )
                }
            }
        }];

    const columnsSave = [
        {
            name: "Nama Dokter",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Kode Booking",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No Antrian",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Klinik",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Appointment Date",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Jam Mulai - Jam Selesai",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No RM",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 110 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Nama Pasien",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Tanggal Lahir",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "NIK",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Alamat",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Jenis Kelamin",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No Telepon",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No Handphone",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Sequence",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Opsi Pembayaran",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "No Rujukan BPJS",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', minWidth: 155 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontWeight: '600' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', minWidth: 100, textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }];

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            <Snackbar open={openAlert} autoHideDuration={5000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {visiblePreview ?
                <div style={{ width: '40%', position: 'absolute', left: 10, top: 15, zIndex: '10', display: 'flex' }}>
                    <button style={{ padding: 5, backgroundColor: errorPreview ? 'gray' : '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none', cursor: errorPreview ? 'default' : 'pointer' }}
                        onClick={() => errorPreview ? null : handleSave()}
                    >
                        <div style={{ display: 'flex', padding: '0 10px' }}>
                            {/* <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" /> */}
                            <Typography style={{ fontSize: 13, margin: 'auto', color: 'white' }}>Simpan</Typography>
                        </div>
                    </button>
                    <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none', marginLeft: 20 }}
                        onClick={() => {
                            setVisiblePreview(false)
                            setDataTable([])
                        }}
                    >
                        <div style={{ display: 'flex', padding: '0 10px' }}>
                            {/* <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" /> */}
                            <Typography style={{ fontSize: 13, margin: 'auto', color: 'white' }}>Batal</Typography>
                        </div>
                    </button>
                </div> :
                previewSave ?
                    <div style={{ width: '40%', position: 'absolute', left: 10, top: 15, zIndex: '10', display: 'flex' }}>
                        <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                            onClick={() => setPreviewSave(false)}
                        >
                            <div style={{ display: 'flex', padding: '0 10px' }}>
                                {/* <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" /> */}
                                <Typography style={{ fontSize: 13, margin: 'auto', color: 'white' }}>Kembali</Typography>
                            </div>
                        </button>
                    </div> :
                    <div style={{ width: '40%', position: 'absolute', left: 10, top: 15, zIndex: '10', display: 'flex' }}>
                        <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                            onClick={() => onUpload()}
                        >
                            <div style={{ display: 'flex', padding: '0 10px' }}>
                                {/* <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" /> */}
                                <Typography style={{ fontSize: 13, margin: 'auto', color: 'white' }}>Upload File</Typography>
                            </div>
                        </button>
                        <ExcelFile
                            element={
                                <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none', marginLeft: 20 }}>
                                    <div style={{ display: 'flex', padding: '0 10px' }}>
                                        {/* <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" /> */}
                                        <Typography style={{ fontSize: 13, margin: 'auto', color: 'white' }}>Download Template</Typography>
                                    </div>
                                </button>
                            }
                            filename={`Template Upload Appointment`}
                        >
                            <ExcelSheet dataSet={multiDataSet} name="Sheet" />
                        </ExcelFile>
                    </div>}
            {visiblePreview && (
                <div >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={dataTable}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            )}

            {previewSave && (
                <div >
                    <div style={{ alignSelf: 'center', position: 'absolute', top: 30, right: 100, zIndex: 2 }}>
                        <ExcelFile
                            element={
                                <LightTooltip title={"Download Appointment"} arrow>
                                    <div style={{ cursor: 'pointer', display: 'flex' }}>
                                        <img src={ic_downloadFile} style={{ width: 24, height: 24, marginRight: 16 }} />
                                    </div>
                                </LightTooltip>
                            }

                            filename={`Appointment`}
                        >
                            <ExcelSheet dataSet={multiDataSave} name="Sheet" />
                        </ExcelFile>
                    </div>
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={dataTableSave}
                            columns={columnsSave}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            )}

            {visibleupload && (
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setvisibleupload(false)}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <div>
                            <UploadFile
                                type={uploadstatus}
                                percentage={percentage}
                                result={result}
                                acceptedFiles={["xlsx"]}
                                onHandle={(dt) => {
                                    fileHandler(dt)
                                    setuploadstatus('idle')
                                    setpercentage('0')
                                }}
                                onUpload={() => {
                                    isUpload && checkPreview()
                                    // this.uploadAttachment(this.state.formData)
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
